module.exports = __webpack_public_path__ + "7e9934b80bcaef58fcfa663aa95266a6.pdf";